import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
// import { numberToMillons } from 'src/utils/functions';
import Loading from 'src/components/global/Loading';

interface ProcesoContent {
  content: {
    data: any;
  };
  spinner,
  channel: string,
}

const Proceso: FC<ProcesoContent> = ({
  content, spinner, channel
}) => {
  const title = 'Proceso';
  return (
    <Box>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                <TableCellHeaderBasic colSpan={5}>&nbsp;</TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                {channel !== 'usuario'
                  ? <TableCellHeaderBasic>Canal</TableCellHeaderBasic>
                  : <TableCellHeaderBasic>Usuario</TableCellHeaderBasic>}
                <TableCellHeaderBasic align="center">
                  Número
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  Monto
                </TableCellHeaderBasic>
                <TableCellHeaderBasic align="center">
                  %
                </TableCellHeaderBasic>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                  spinner && (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
              {!spinner && content.data.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index}>
                  <TableCell>{item.nombreComercial}</TableCell>
                  <TableCell align="center">
                    {item.numero}
                  </TableCell>
                  <TableCell align="center">
                    {item.monto}
                  </TableCell>
                  <TableCell align="center">
                    {item.porcentaje}
                    &nbsp;%
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default Proceso;
